import React, {useEffect} from "react";
import { Fade } from "react-awesome-reveal";
import { useNavigate } from "react-router-dom";
import playstore from "../../assets/playstore.png";
import appstore from "../../assets/app_store.png";
import QRCode from "../../assets/qr_new.png";
import EventNavbarComponent from "../events/eventNavbar";
import SEO from "../common/seo";

const SubscribeScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      window.location.href = "https://onelink.to/a9kcfx";
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      style={{ background: "#000", color: "white" }}
      className="container landing-page-main"
    >
      <SEO title="Subscription Successful - Creedom" description="" />
      <div className="landing-page-main">
        <EventNavbarComponent />
      </div>
      <div
        style={{
          position: "relative",
          left: 0,
          width: "100%",
          height: "1px",
          background: "#393939",
          zIndex: 1,
        }}
      ></div>

<div
        className="mt-5"
        style={{ justifyContent: "center", display: "flex", }}
      >
        <div
          className="head"
          style={{
            width: 450
          }}
        >
          <div className="head-div">
            <Fade direction="up" cascade>
              <div className="">
                <div className="ct-text-left ct-border-gray p-3 ct-border-radius-10 text-center">
                  <h1 className="ct-cirka-size-30">
                  You are already subscribed!
                  </h1>
                  <div className="mt-2 mb-3">
                    <p className="panel-sub-title">
                    Thank you for being a PRO member. Download the Creedom
                    app to access all premium content.
                    </p>
                  </div>
                </div>

                <div className="p-4 ct-border-radius-10">
                  <div className="text-center">
                    <img src={QRCode} width={100} />
                  </div>
                  <div className="text-center pt-3">
                    <p className="ct-text-24 ct-text-gray">
                      Download the{" "}
                      <span className="ct-text-light"> Creedom App</span> from
                      the Play Store or the App Store
                    </p>
                  </div>
                  <div className="ct-display-flex ct-justify-center pt-3">
                    <div className="">
                      <a
                        href="https://fv4b.short.gy/PKKWyx"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={playstore}
                          width={150}
                          style={{ marginRight: 20 }}
                        />
                      </a>
                    </div>
                    <div className="">
                      <a
                        href="https://fv4b.short.gy/YCG6ws"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={appstore}
                          width={150}
                          style={{ marginTop: 10 }}
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </Fade>
          </div>
        </div>
      </div>


    </div>
  );
};

export default SubscribeScreen;


